module.exports = __webpack_public_path__ + "3520590ca5c0502f023d757f402822e9.png";